const UNREAD_COUNTS_KEY = 'inbox_unread_counts';
const UNREAD_MESSAGE_IDS_KEY = 'inbox_unread_message_ids';
const TOTAL_UNREAD_COUNT_KEY = 'inbox_total_unread_count';
export const loadUnreadCounts = () => {
    try {
        const stored = localStorage.getItem(UNREAD_COUNTS_KEY);
        return stored ? JSON.parse(stored) : {};
    }
    catch (error) {
        console.warn('Failed to load unread counts from localStorage:', error);
        return {};
    }
};
export const saveUnreadCounts = (unreadCounts) => {
    try {
        localStorage.setItem(UNREAD_COUNTS_KEY, JSON.stringify(unreadCounts));
    }
    catch (error) {
        console.warn('Failed to save unread counts to localStorage:', error);
    }
};
export const loadUnreadMessageIds = () => {
    try {
        const stored = localStorage.getItem(UNREAD_MESSAGE_IDS_KEY);
        return stored ? JSON.parse(stored) : {};
    }
    catch (error) {
        console.warn('Failed to load unread message IDs from localStorage:', error);
        return {};
    }
};
export const saveUnreadMessageIds = (unreadMessageIds) => {
    try {
        localStorage.setItem(UNREAD_MESSAGE_IDS_KEY, JSON.stringify(unreadMessageIds));
    }
    catch (error) {
        console.warn('Failed to save unread message IDs to localStorage:', error);
    }
};
export const loadTotalUnreadCount = () => {
    try {
        const stored = localStorage.getItem(TOTAL_UNREAD_COUNT_KEY);
        return stored ? parseInt(stored, 10) : 0;
    }
    catch (error) {
        console.warn('Failed to load total unread count from localStorage:', error);
        return 0;
    }
};
export const saveTotalUnreadCount = (count) => {
    try {
        localStorage.setItem(TOTAL_UNREAD_COUNT_KEY, count.toString());
    }
    catch (error) {
        console.warn('Failed to save total unread count to localStorage:', error);
    }
};
export const clearUnreadCounts = () => {
    try {
        localStorage.removeItem(UNREAD_COUNTS_KEY);
        localStorage.removeItem(UNREAD_MESSAGE_IDS_KEY);
        localStorage.removeItem(TOTAL_UNREAD_COUNT_KEY);
    }
    catch (error) {
        console.warn('Failed to clear unread counts from localStorage:', error);
    }
};
export const updateUnreadCountForConversation = (conversationId, increment) => {
    const currentCounts = loadUnreadCounts();
    const currentTotal = loadTotalUnreadCount();
    let newTotal = currentTotal;
    const newCounts = Object.assign({}, currentCounts);
    if (increment) {
        newCounts[conversationId] = (newCounts[conversationId] || 0) + 1;
        newTotal = currentTotal + 1;
    }
    else {
        const conversationCount = newCounts[conversationId] || 0;
        if (conversationCount > 0) {
            newTotal = Math.max(0, currentTotal - conversationCount);
            delete newCounts[conversationId];
        }
    }
    saveUnreadCounts(newCounts);
    saveTotalUnreadCount(newTotal);
    return {
        totalCount: newTotal,
        unreadCounts: newCounts,
    };
};
export const addUnreadMessageId = (conversationId, messageId) => {
    const currentUnreadCounts = loadUnreadCounts();
    const currentUnreadMessageIds = loadUnreadMessageIds();
    if (!currentUnreadMessageIds[conversationId]) {
        currentUnreadMessageIds[conversationId] = [];
    }
    if (!currentUnreadMessageIds[conversationId].includes(messageId)) {
        currentUnreadMessageIds[conversationId].push(messageId);
        currentUnreadCounts[conversationId] = (currentUnreadCounts[conversationId] || 0) + 1;
    }
    const totalCount = Object.values(currentUnreadCounts).reduce((sum, count) => sum + count, 0);
    saveUnreadCounts(currentUnreadCounts);
    saveUnreadMessageIds(currentUnreadMessageIds);
    saveTotalUnreadCount(totalCount);
    return {
        totalCount,
        unreadCounts: currentUnreadCounts,
        unreadMessageIds: currentUnreadMessageIds,
    };
};
export const removeUnreadMessageId = (conversationId, messageId) => {
    const currentUnreadCounts = loadUnreadCounts();
    const currentUnreadMessageIds = loadUnreadMessageIds();
    if (currentUnreadMessageIds[conversationId]) {
        const index = currentUnreadMessageIds[conversationId].indexOf(messageId);
        if (index > -1) {
            currentUnreadMessageIds[conversationId].splice(index, 1);
            currentUnreadCounts[conversationId] = Math.max(0, (currentUnreadCounts[conversationId] || 0) - 1);
            if (currentUnreadMessageIds[conversationId].length === 0) {
                delete currentUnreadMessageIds[conversationId];
                delete currentUnreadCounts[conversationId];
            }
        }
    }
    const totalCount = Object.values(currentUnreadCounts).reduce((sum, count) => sum + count, 0);
    saveUnreadCounts(currentUnreadCounts);
    saveUnreadMessageIds(currentUnreadMessageIds);
    saveTotalUnreadCount(totalCount);
    return {
        totalCount,
        unreadCounts: currentUnreadCounts,
        unreadMessageIds: currentUnreadMessageIds,
    };
};
